export default (dinheiro, decimais) => {
    if (!dinheiro) return 'R$ 0,00'

    var casasDecimais =  dinheiro.toString().split('.')[1]
    var ultimoDigito = (casasDecimais && casasDecimais.toString().length > 2) ? Number(casasDecimais.slice(-1)) : 0
    var qtdDecimais = decimais ? decimais : (ultimoDigito ? 3 : 2)
    
    const d = Number(dinheiro).toFixed(qtdDecimais)
    return `R$ ${d.toString().replace('.', ',')}`
}
